import { Navigate, RouteObject } from "react-router-dom";
import { TabPanel } from "@mui/lab";
import DatasetPageLayout from "datasets/components/DatasetPageLayout";
import usePermissions from "datasets/hooks/usePermissions";
import DatasetTableList from "datasets/pages/tables/components/DatasetTableList";
import AddTable from "datasets/pages/tables/pages/AddTable";
import DatasetTable from "datasets/pages/tables/pages/DatasetTable";
import { useSafeRoutes } from "~/hooks/useSafeRoutes";
import { ROUTE_404 } from "~/router/constants";

const ProtectedAddTable = () => {
  const canCreate = usePermissions("create:catalog-ingest");
  if (!canCreate) return <Navigate to={ROUTE_404} replace />;
  return <AddTable />;
};

const routeDefinitions: RouteObject[] = [
  { index: true, element: <DatasetTableList /> },
  { path: ":tableFQN", element: <DatasetTable /> },
  { path: "new", element: <ProtectedAddTable /> },
];

const DatasetTables = () => {
  const routes = useSafeRoutes(routeDefinitions);

  return (
    <TabPanel value="tables" sx={{ p: 0 }}>
      <DatasetPageLayout>{routes}</DatasetPageLayout>
    </TabPanel>
  );
};

export default DatasetTables;
